// Full-screen pause menu (in-match overlay — the Match component never unmounts).

import { useState } from 'react';
import { SettingsScreen } from './screens/Settings';
import type { SettingsData } from '../app/persistence';

export function PauseMenu({
  open,
  onResume,
  onRestart,
  onConcede,
  onSettingsChanged,
  online = false,
}: {
  open: boolean;
  onResume: () => void;
  onRestart: () => void;
  onConcede: () => void;
  onSettingsChanged: (s: SettingsData) => void;
  online?: boolean;
}) {
  const [showSettings, setShowSettings] = useState(false);
  if (!open) return null;
  return (
    <div className="overlay pausemenu">
      {showSettings ? (
        <SettingsScreen onBack={() => setShowSettings(false)} onChanged={onSettingsChanged} />
      ) : (
        <div className="pausecard">
          <h2>{online ? 'MATCH MENU' : 'PAUSED'}</h2>
          <div className="menubuttons">
            <button className="btn primary" onClick={onResume}>
              ▶ Resume
            </button>
            <button className="btn" onClick={() => setShowSettings(true)}>
              ⚙ Settings
            </button>
            {!online && <button className="btn" onClick={onRestart}>
              ↺ Restart match
            </button>}
            <button className="btn danger" onClick={onConcede}>
              ⚑ Concede — main menu
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
